import { Tag } from "antd";
import React from "react";
import {FileOutlined} from '@ant-design/icons';


interface FileTagProps {
  name: string;
  closeable?: boolean;
  onClose?: (tag: string) => void;
}

const FileTag: React.FC<FileTagProps> = ({ name, closeable = false, onClose }) => {
  return <Tag color="purple" icon={<FileOutlined />} closable={closeable}  onClose={() => onClose?.(name)}> {name} </Tag>;
};

export default FileTag